<template>
  <div class="home">
    <div class="grid-container">
      <div class="grid-x grid-margin-x">
        <div class="cell small-12 text-center">
          <p>Chcesz zagrać w Picipolo?</p>
          <router-link to="/gram" tag="button" class="success button">Tak</router-link>&nbsp;
          <router-link to="/nie-gram" tag="button" class="alert button">Nie</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'home',

}
</script>
